import { Link } from "react-router-dom";
import Container from "@/components/Container";
import Logo from "@/components/Logo";

export default function PublicFooter({ cms }) {
  const footer = cms?.footer || {};
  const contact = cms?.contact || {};
  return (
    <footer className="relative mt-32 bg-ink-900 text-cream-100" data-testid="public-footer">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-ruby to-transparent" />

      <Container className="py-24 grid grid-cols-1 md:grid-cols-12 gap-16">
        <div className="md:col-span-6">
          <Logo size={32} tone="cream" />
          <h3 className="mt-10 serif-display text-4xl lg:text-5xl text-cream-100 max-w-md">
            Write to <span className="serif-italic text-ruby-light">the house</span>.
          </h3>
          <a
            href={`mailto:${contact.email || "info@rubys.group"}`}
            className="mt-6 inline-block serif-light text-2xl lg:text-3xl text-cream-100 hover:text-ruby-light transition-colors"
          >
            {contact.email || "info@rubys.group"} →
          </a>
        </div>

        <div className="md:col-span-3">
          <p className="label-mono mb-6" style={{ color: "#B83A52" }}>The House</p>
          <ul className="space-y-3 text-cream-100/70">
            <li><Link to="/about" className="hover:text-cream-100 transition-colors">About</Link></li>
            <li><Link to="/process" className="hover:text-cream-100 transition-colors">Our Method</Link></li>
            <li><Link to="/properties" className="hover:text-cream-100 transition-colors">Portfolio</Link></li>
            <li><Link to="/before-after" className="hover:text-cream-100 transition-colors">Transformations</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="label-mono mb-6" style={{ color: "#B83A52" }}>Engage</p>
          <ul className="space-y-3 text-cream-100/70">
            <li><Link to="/sell" className="hover:text-cream-100 transition-colors">Sell to Rubys</Link></li>
            <li><Link to="/investors" className="hover:text-cream-100 transition-colors">Become a Partner</Link></li>
            <li><Link to="/work-with-us" className="hover:text-cream-100 transition-colors">Join the Register</Link></li>
            <li><Link to="/contact" className="hover:text-cream-100 transition-colors">Contact</Link></li>
          </ul>
        </div>
      </Container>

      <Container className="py-7 border-t border-cream-100/10 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-[0.7rem] text-cream-100/40 tracking-[0.15em] font-mono">
          {footer.text || "© Rubys.Group · An English Property House"}
        </p>
        <p className="text-[0.7rem] text-cream-100/40 tracking-[0.15em] font-mono">
          Acquire — Redesign — Renovate — Resell
        </p>
      </Container>
    </footer>
  );
}
